<div id="container">
    <input id="color" type="color" [(ngModel)]="color" value="{{color}}" (change)="updateColor()"/>
    <label class="colorBtn" for="color"  [style.backgroundColor]="color"></label>
    <div id="description" contenteditable="true" (blur)="updateProject()">{{project.description}}</div>
</div>

